module.exports = __webpack_public_path__ + "media/images/site/CENSINO_FUND_1_PROPOSTA_EDUC-b0d1919c1e753a07c154df1ee6721943.jpg";